import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import referencesData from 'ressources/labels/references.json';

export default function AboutButton() {
	const [isModalVisible, setIsModalVisible] = useState(false);
	const { t } = useTranslation();

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const sortedReferences = referencesData.sort((a, b) => a.id.localeCompare(b.id));

	return (
		<>
			<Button onClick={showModal} className="about-button">
				{t('aboutButtonLabel')}
			</Button>
			<Modal
				title={t('aboutButtonLabel')}
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null} // Customize footer if needed
				className="about-modal"
				width={1000} // Set the desired width here
				centered // Center the modal on the screen
				style={{ top: 20 }} // Adjust the top position as needed
			>
				<div className="modal-content">
					<p>{t('about.conceptualization')}</p>
					<p>{t('about.contents')}</p>
					<p>{t('about.programming_original')}</p>
					<p>{t('about.programming_update')}</p>
					<p>{t('about.translations')}</p>
					<p>{t('about.refinements')}</p>
					<p>{t('about.source')} <a href={t('about.source_url')} target="_blank" rel="noopener noreferrer">{t('about.source_url')}</a></p>
					<p>
						{t('about.contact_text')}
						<a href={`mailto:${t('about.contact_email')}`}>
							{t('about.contact_email')}
						</a>
					</p>
					<h3 style={{ marginTop: '20px' }}>{t('references')}</h3>
					<div className="reference-box">
						<ul>
							{sortedReferences.map(ref => (
								<li key={ref.id}>
									{ref.citation}
									{ref.link && <a href={ref.link} target="_blank" rel="noopener noreferrer">Link</a>}
								</li>
							))}
						</ul>
					</div>
				</div>
			</Modal>
		</>
	);
}